/**
 * @Author:      ge.yuankai
 * @DateTime:    2018-03-14
 * @Description: 图文稿详情
 */
'use strict';
angular.module("videoDetailModule",[]).
controller('videoDetailCtrl', ['$scope', '$stateParams', 'httpService','playVideoService','$sce','$element', function($scope, $stateParams, httpService, playVideoService,$sce,$element) {
	initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
        };
        $scope.listData = [];
        $scope.params = {
            articleId: $stateParams.articleId
        };
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {
        requestData()
    }
    /**
     * [requestData description] 初始化列表数据
     */
    function requestData() {
        $scope.loadingPromise = httpService.http("/mcnww/web/pgcArticle/findById.do", $scope.params, "get").then(function(data) {
            $scope.listData = data.articeInfo;
            $scope.listData.articleHtmlCon = $sce.trustAsHtml(data.articeInfo.articleHtmlCon);
            $scope.status.channels = data.chnlsAndTags;
            $scope.status.videoIds = JSON.parse(data.articeInfo.videos);
            getVideoImage();//获取视频的图片
            getVideoUrl();
        });
    }
    //获取播放视频的图片
    function getVideoImage(){
		httpService.http("/mcnww/web/cloud/getMediaFrame.do", {id:$scope.status.videoIds[0].id,libType:201}, "get").then(function(data) {
			$scope.status.videoImageUrl = data.data.mediaFrameUrl;
	    });
    }
    //获取播放视频的地址
    function getVideoUrl(){
		httpService.http("/mcnww/web/cloud/getVideoUrl.do", {id: $scope.status.videoIds[0].id,libType:201}, "get").then(function(data) {
			if(data.data.videoUrl) {
				$scope.status.videoUrl = $sce.trustAsResourceUrl(data.data.videoUrl);
			}
		});
    }
    $scope.playVideo = function(){
        // debugger;
    	// var v = $element.find("video")[0];
    	// if(v.paused){
    	// 	v.play();
    	// }else{
    	// 	v.pause();
    	// }
        document.getElementById("myVideo").play();
    }   
    /**
     * [openVideo description] 打开视频播放
     * @return {[type]} [description]
     */
    $scope.openVideo = function(){
    	playVideoService.openPlayVideoPage($scope.status.videoIds[0].id,'video',false);
    }
    /**
     * [initCover description] 初始化封面
     * @param  {[type]} item [description] 渠道信息
     * @return {[type]}      [description]
     */
    $scope.initCover = function(item) {
        item.coverImg = JSON.parse(item.coverImg);
    };
}]);